import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAEaXTbKtYXG5cbG7PPLu1ilEdm6atJL0U",
  authDomain: "sagetechapp.firebaseapp.com",
  projectId: "sagetechapp",
  storageBucket: "sagetechapp.firebasestorage.app",
  messagingSenderId: "232471932028",
  appId: "1:232471932028:web:f5b2b65091417b8234edf9", // Customer Portal app ID
  measurementId: "G-8V3DG4BKNB",
};

export const app = initializeApp(firebaseConfig);

// App Check — invisible reCAPTCHA v3 bot protection
// Blocks bots, scrapers, and abuse from ever touching Firebase
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LeLJuAsAAAAAOy6LRt4iI1a7t0qLUb5N88x1isu"),
  isTokenAutoRefreshEnabled: true,
});

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
